// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"08624cd9","562":"f614d8a6"}[chunkId] + ".chunk.css";
};